import MyAccountService from "../../services/MyAccountService";
import ServicesService from "../../services/ServicesService";


class AppConfig {
  constructor() {
    this.attrs = {};
  }

  async fetch() {
    let account;
    try {
      account = await MyAccountService.fetch();
    } catch (error) {
      this.attrs = {};
      throw error;
    }
    if (account.getOrganizationId()) {
      this.attrs.accountId = account.getId();
      this.attrs.organizationId = account.getOrganizationId();
      const services = await ServicesService.getOrganizationServices({
        organizationId: account.getOrganizationId(),
      });
      if (services.length) {
        this.attrs.serviceId = services[0].id;
        this.attrs.storeName = services[0].name;
      }
    }
    return account;
  }

  getServiceId() {
    return this.attrs.serviceId;
  }

  getStoreName() {
    return this.attrs.storeName;
  }

  getAccountId() {
    return this.attrs.accountId;
   }

  getOrganizationId() {
    return this.attrs.organizationId;
  }

  setOrganizationId(organizationId) {
    this.attrs.organizationId = organizationId;
  }

  getAccount() { }

  isOwner() { }

  isStaff() {
    return this.attrs.isStaff;
  }
}

export default new AppConfig();
